// extracted by mini-css-extract-plugin
export default {"rightModal":"RightModal_rightModal__q8LgO","buttonContainer":"RightModal_buttonContainer__u2ecJ"};